import { LOCALE } from "../../constant";

// const MILLISECONDS_IN_WEEK = 604_800_000;
// const firstDayOfWeek = 1; // 0 = sunday...

/**
 * @function getDayTwoLine displays the date in a format
 * 
 * xx/xx
 *  
 * Day
 * @param dateDay a number for a the timestamp's date
 * @param dateName a string for date's name
 * @returns {JSX.Element} HTML content
 */
function getDayTwoLine(dateDay: number, dateName: string) {
    const date: Date = new Date(dateDay * 1000);

    const day = date.toLocaleDateString(LOCALE, { day: "2-digit" });
    const month = date.toLocaleDateString(LOCALE, { month: "long" });

    return (
        <>
            <div className="mr-2">
                {dateName} {day} {month}
            </div>
        </>
    );
}

/**
 * @function getSunday returns the sunday corresponding to the parameter date
 * @param date a date
 * @returns {date} a date
 */
function getSunday(date: Date) {
    const sunday = new Date(date);

    /*
     * numberDay = 0 => Sunday
     * numberDay = 1 => Monday
     * ...
     * numberDay = 6 => Saturday
     */
    const numberDay = date.getDay();

    /* if the current day is between monday and friday the sunday we want is the first day of the week*/
    if (numberDay >= 1 && numberDay <= 5) {
        sunday.setDate(sunday.getDate() - numberDay);
    }
    /* else if the current day is saturday the sunday is the next day and if the current day is sunday we don't need any change */
    else {
        sunday.setDate(sunday.getDate() + 1 - ((numberDay + 1) % 7));
    }
    return sunday;
}

/**
 * @function getWeek retrieves the number of the week of the current day
 * @param date a date
 * @returns {number} number
 */
function getWeek(date: Date): number {
    // Copier la date pour éviter de modifier l'original
    date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    // Définir le premier jour de la semaine comme le lundi
    date.setUTCDate(date.getUTCDate() + 4 - (date.getUTCDay() || 7));
    // Obtenir le premier jour de l'année
    const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
    // Calculer le numéro de la semaine
    const weekNo = Math.ceil(((date.getTime() - yearStart.getTime()) / 86_400_000 + 1) / 7);
    return weekNo;
}

/**
 * @function dateToTimestamp take a date and return the associated timestamp
 * @param date a date
 * @returns {number} number
 */
function dateToTimestamp(date: Date) {
    const timestampDate = Math.floor(date.getTime() / 1000);
    return timestampDate;
}

/**
 * @function is5PM return a boolean if the current hour is after 5PM
 * @returns {boolean} boolean
 */
function isHourLimit(coworkerHourLimit: string, dailyReservationDate: number): boolean {
    const now = new Date();
    const targetTime = new Date(dailyReservationDate*1000)
    
    targetTime.setHours(Number.parseInt(coworkerHourLimit));
    targetTime.setMinutes(0);
    targetTime.setSeconds(0);
    return now.getTime() >= targetTime.getTime()
}

function isOld(dateTimestampToCompare: number): boolean {
    dateTimestampToCompare += 86_400;
    const today = new Date();
    today.setHours(23, 59, 59, 59);
    const timestamp = today.getTime() / 1000;
    return timestamp >= dateTimestampToCompare;
}
export { getWeek, getSunday, getDayTwoLine, dateToTimestamp, isHourLimit, isOld }; 